<template>
  <svg class="Icon" aria-hidden="true">
      <use :xlink:href="`${require('/src/assets/icons.svg')}#${name}`"></use>
  </svg>
</template>

<script>
export default {
  props: {
    name: {
      type: String,
      default: ""
    }
  }
};
</script>
